import { Box } from "@mui/material"
import { Dayjs } from "dayjs"
import React, { useState } from "react"
import { useMediaQuery } from "react-responsive"
import { useLoginContext } from "src/hooks/useLoginContext"
import { MEMBER_TYPE, MENU_TYPE, SUB_MENU_TYPE } from "src/modules/const"
import { CommonLayout } from "../CommonLayout"
import { EventListPage } from "../event/EventListPage"
import { EventSearchItem } from "../event/EventSearchItem"
import { TopMenuItem } from "../TopMenuItem"
import { ConsultAdminListPage } from "./ConsultAdminListPage"
import { ConsultAdviserListPage } from "./ConsultAdviserListPage"
import { ConsultSearchItem } from "./ConsultSearchItem"
import { ConsultUserListPage } from "./ConsultUserListPage"
import { ContactListPage } from "./ContactListPage"
import { EventPageItem } from "./EventPageItem"

interface Props {
  subMenuIndex: number
}

export const InboxPage = ({ subMenuIndex }: Props) => {
  const { userType } = useLoginContext()
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })

  const [fromDate, setFromDate] = useState<Dayjs | null>(null)
  const [toDate, setToDate] = useState<Dayjs | null>(null)
  const [areaID, setAreaID] = useState<number[]>([])

  const [categories, setCategories] = useState<number[]>([])

  const adminSubMenu = [
    {
      title: "consult",
      icon: "consult",
      index: SUB_MENU_TYPE.INBOX_CONSULT,
      page: <ConsultAdminListPage fromDate={fromDate} toDate={toDate} areaID={areaID} />,
      search: (
        <ConsultSearchItem
          fromDate={fromDate}
          toDate={toDate}
          handleFromDate={setFromDate}
          handleToDate={setToDate}
          areaID={areaID}
          handleAreaID={setAreaID}
        />
      ),
      link: "/inbox/consult",
    },
    {
      title: "event",
      icon: "event",
      index: SUB_MENU_TYPE.INBOX_EVENT,
      page: (
        <EventListPage
          fromDate={fromDate}
          toDate={toDate}
          areaID={areaID}
          categories={categories}
        />
      ),
      search: (
        <EventSearchItem
          fromDate={fromDate}
          toDate={toDate}
          handleFromDate={setFromDate}
          handleToDate={setToDate}
          areaID={areaID}
          handleAreaID={setAreaID}
          categories={categories}
          handleCategories={setCategories}
        />
      ),
      link: "/inbox/event",
    },
    {
      title: "contact_state",
      icon: "contact",
      index: SUB_MENU_TYPE.INBOX_CONTACT,
      page: <ContactListPage />,
      search: <></>,
      link: "/inbox/contact",
    },
  ]

  const userSubMenu = [
    {
      title: "consult",
      icon: "consult",
      index: SUB_MENU_TYPE.INBOX_CONSULT,
      page: <ConsultUserListPage fromDate={fromDate} toDate={toDate} areaID={areaID} />,
      search: (
        <ConsultSearchItem
          fromDate={fromDate}
          toDate={toDate}
          areaID={areaID}
          handleFromDate={setFromDate}
          handleToDate={setToDate}
          handleAreaID={setAreaID}
        />
      ),
      link: "/inbox/consult",
    },
    {
      title: "event",
      icon: "event",
      index: SUB_MENU_TYPE.INBOX_EVENT,
      page: (
        <EventPageItem
          fromDate={fromDate}
          toDate={toDate}
          areaID={areaID}
          categories={categories}
        />
      ),
      search: (
        <EventSearchItem
          fromDate={fromDate}
          toDate={toDate}
          handleFromDate={setFromDate}
          handleToDate={setToDate}
          areaID={areaID}
          handleAreaID={setAreaID}
          categories={categories}
          handleCategories={setCategories}
        />
      ),
      link: "/inbox/event",
    },
  ]

  const adviserSubMenu = [
    {
      title: "consult",
      icon: "consult",
      index: SUB_MENU_TYPE.INBOX_CONSULT,
      page: <ConsultAdviserListPage fromDate={fromDate} toDate={toDate} areaID={areaID} />,
      search: (
        <ConsultSearchItem
          fromDate={fromDate}
          toDate={toDate}
          areaID={areaID}
          handleFromDate={setFromDate}
          handleToDate={setToDate}
          handleAreaID={setAreaID}
        />
      ),
      link: "/inbox/consult",
    },
    {
      title: "event",
      icon: "event",
      index: SUB_MENU_TYPE.INBOX_EVENT,
      page: (
        <EventPageItem
          fromDate={fromDate}
          toDate={toDate}
          areaID={areaID}
          categories={categories}
        />
      ),
      search: (
        <EventSearchItem
          fromDate={fromDate}
          toDate={toDate}
          handleFromDate={setFromDate}
          handleToDate={setToDate}
          areaID={areaID}
          handleAreaID={setAreaID}
          categories={categories}
          handleCategories={setCategories}
        />
      ),
      link: "/inbox/event",
    },
  ]

  let subMenu: any[] = []
  switch (userType) {
    case MEMBER_TYPE.USER:
    case MEMBER_TYPE.COMPANY:
      subMenu = userSubMenu
      break
    case MEMBER_TYPE.ADMINISTRATOR:
      subMenu = adminSubMenu
      break
    case MEMBER_TYPE.ADVISER:
      subMenu = adviserSubMenu
  }

  return (
    <>
      {isTablet ? (
        <></>
      ) : (
        <Box position="absolute" sx={{ width: "100%", height: "60px" }}>
          <Box display="flex">
            <TopMenuItem
              mainMenuIndex={MENU_TYPE.INBOX}
              subMenuIndex={subMenuIndex}
              fromDate={fromDate}
              toDate={toDate}
              areaID={areaID}
              categories={categories}
              handleFromDate={setFromDate}
              handleToDate={setToDate}
              handleAreaID={setAreaID}
              handleCategories={setCategories}
            />
          </Box>
        </Box>
      )}

      <CommonLayout subMenu={subMenu} subMenuIndex={subMenuIndex} />
    </>
  )
}
